/**
 * SMALL GIANTS — riscrive il copy del banner privacy nativo Shopify
 * (Shopify non offre un campo Admin per personalizzare questo testo)
 * e coordina la bolla chat Chatwoot per non sovrapporsi al banner.
 * Il layout/colori dei bottoni sono gestiti in sg-cookie-consent.css
 * sugli id reali (#shopify-pc__banner__btn-accept ecc.).
 */
(function () {
  var BANNER_ID = 'shopify-pc__banner';

  // Testi per lingua. La lingua arriva da <html lang="{{ request.locale.iso_code }}"> (layout/theme.liquid).
  // Per una lingua non elencata il banner resta quello nativo di Shopify, gia' tradotto.
  var COPY_BY_LANG = {
    it: {
      title: 'Usiamo i cookie',
      bodyPrefix: 'Ci servono per far funzionare bene il sito, capire cosa vi piace e mostrarvi contenuti pertinenti. Nessun cookie non essenziale parte senza il vostro ok. Dettagli nella ',
      bodySuffix: '.',
      accept: 'Accetta tutti',
      decline: 'Rifiuta tutti',
      manage: 'Gestisci preferenze'
    },
    en: {
      title: 'We use cookies',
      bodyPrefix: 'They keep the site running smoothly, help us understand what you like and show you relevant content. No non-essential cookie runs without your OK. Details in our ',
      bodySuffix: '.',
      accept: 'Accept all',
      decline: 'Decline all',
      manage: 'Manage preferences'
    },
    de: {
      title: 'Wir verwenden Cookies',
      bodyPrefix: 'Sie sorgen dafür, dass die Website gut funktioniert, dass wir verstehen, was dir gefällt, und dass wir dir passende Inhalte zeigen. Kein nicht notwendiges Cookie wird ohne dein OK gesetzt. Details findest du in der ',
      bodySuffix: '.',
      accept: 'Alle akzeptieren',
      decline: 'Alle ablehnen',
      manage: 'Einstellungen verwalten'
    }
  };
  var LANG = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
  var COPY = COPY_BY_LANG[LANG] || null;

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function rewrite(banner) {
    if (!COPY || !banner || banner.dataset.sgRewritten === '1') return;

    var title = document.getElementById('shopify-pc__banner__body-title');
    var link = document.getElementById('shopify-pc__banner__body-policy-link');
    var accept = document.getElementById('shopify-pc__banner__btn-accept');
    var decline = document.getElementById('shopify-pc__banner__btn-decline');
    var manageSpan = document.querySelector('#shopify-pc__banner__btn-manage-prefs span');

    if (!title || !link || !accept || !decline) return; // non ancora renderizzato del tutto

    title.textContent = COPY.title;

    var p = link.parentElement;
    while (p.firstChild) p.removeChild(p.firstChild);
    p.appendChild(document.createTextNode(COPY.bodyPrefix));
    p.appendChild(link); // stesso nodo: href/target/rel invariati
    p.appendChild(document.createTextNode(COPY.bodySuffix));

    accept.textContent = COPY.accept;
    decline.textContent = COPY.decline;
    if (manageSpan) manageSpan.textContent = COPY.manage;

    banner.dataset.sgRewritten = '1';
  }

  function sync() {
    var banner = document.getElementById(BANNER_ID);
    document.body.toggleAttribute('data-sg-consent-open', isVisible(banner));
    if (banner) rewrite(banner);
  }

  sync();

  var observer = new MutationObserver(sync);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
})();
